import React, { useEffect } from 'react'; // SİHİRLİ KOD: useEffect içeri alındı!
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { blogVerisi } from '../data/blogVerisi'; 

function BlogDetay() {
  const { id } = useParams();
  const makale = blogVerisi.find((item) => item.id === id);

  // --- ZORUNLU SEKME EZİCİ MOTOR (KABA KUVVET) ---
  useEffect(() => {
    if (makale && makale.baslik) {
      document.title = `${makale.baslik} | Demir Grup Ankara`;
    }
  }, [makale]);
  // ----------------------------------------------

  if (!makale) {
    return (
      <div className="blog-page-wide-wrapper" style={{ textAlign: 'center', paddingTop: '150px' }}>
        <h2 style={{ color: 'white' }}>Makale Bulunamadı dostum...</h2>
        <Link to="/blog" className="blog-back-link" style={{ color: '#ea580c' }}>Blog'a Dön</Link>
      </div>
    );
  }

  return (
    <div className="blog-page-wide-wrapper">
      
      {/* SİHİRLİ KOD: MAKALE İÇİN VIP GOOGLE TABELASI VE JSON KARTI */}
      <Helmet>
        <title>{makale.baslik} | Demir Grup Ankara</title>
        <meta name="description" content={makale.ozet} />
        <meta name="keywords" content={makale.keywords} />
        
        {/* Sosyal Medya ve WhatsApp Paylaşım Önizlemesi */}
        <meta property="og:title" content={makale.baslik} />
        <meta property="og:description" content={makale.ozet} />
        <meta property="og:type" content="article" />
        
        <link rel="canonical" href={`https://www.ddemirgrup.com.tr/blog/${makale.id}`} />
        
        {/* İŞTE JİLET GİBİ DÜZELTİLMİŞ JSON KİMLİĞİ */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": makale.baslik,
            "image": "https://www.ddemirgrup.com.tr/logo.png",
            "datePublished": "2026-03-10",
            "author": { "@type": "Organization", "name": "Demir Grup İnşaat & Güvenlik Sistemleri" },
            "publisher": {
              "@type": "Organization",
              "name": "Demir Grup",
              "logo": { "@type": "ImageObject", "url": "https://www.ddemirgrup.com.tr/logo.png" }
            },
            "description": makale.ozet
          })}
        </script>
      </Helmet>

      {/* TERTEMİZ, RESİMSİZ, TÜM EKRANI KAPLAYAN MAKALE TASARIMI */}
      <div className="blog-detail-wide-container">
        <Link to="/blog" className="blog-back-link">← Blog Bilgi Merkezine Dön</Link>
        
        <h1 className="blog-detail-wide-title">{makale.baslik}</h1>
        
        <div className="blog-detail-wide-meta">
          <span>📅 {makale.tarih}</span>
          <span>✍️ Demir Grup Mühendislik VIP Makale</span>
        </div>

        {/* Makale İçeriği - Tipografi odalı, okuması lüks */}
        <div 
          className="blog-content-wide-typography" 
          dangerouslySetInnerHTML={{ __html: makale.icerik }} 
        />
        
        {/* Alt Kısım İletişim Bandı - Müşteriyi hemen teklife çekmek için */}
        <div className="blog-contact-banner-wide">
          <h3>Projeniz İçin Uzman Mühendislik Desteğine mi İhtiyacınız Var?</h3>
          <p>Demir Grup mühendisleri tesisinizi incelesin, en uygun altyapıyı birlikte tasarlayalım.</p>
          <Link to="/iletisim" className="btn-primary" style={{ textDecoration: 'none', display: 'inline-block' }}>Hemen Ücretsiz Keşif Talep Edin</Link>
        </div>
      </div>
    </div>
  );
}

export default BlogDetay;